module.exports = __webpack_public_path__ + "static/media/previous-period-line.48779dad.svg";